import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class WorkflowConditionService {

  constructor(private readonly http: HttpClient) { }

  getAllWorkflowConditions(token, workflowID) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    let en_URI = encodeURI(environment.apiUrl + "/workflows/" + workflowID + "/conditions");
    return this.http.get<any>(en_URI, {
      headers: httpHeaders
    });
  }

  getConditionsByAlertType(token, workflowTypeID, alertTypeID, exclude?: string) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });

    // Construct the query param if `exclude` is provided
    const queryString = exclude ? `?exclude=${exclude}` : '';

    return this.http.get<any>(`${environment.apiUrl}/app/workflow_types/${workflowTypeID}/workflow_conditions/${alertTypeID}${queryString}`, {
      headers: httpHeaders
    });
  }

  getWFValuesConditionID(token, workflowTypeID, alertTypeID, conditionID) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.get<any>(`${environment.apiUrl}/app/workflow_types/${workflowTypeID}/workflow_conditions/${alertTypeID}/workflow_values/${conditionID}`, {
      headers: httpHeaders
    });
  }

  addWorkFlowCondition(token, workflowID, params = {}): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
     let en_URI = encodeURI(environment.apiUrl + "/workflows/" + workflowID + "/conditions");
    return this.http.post<any>(en_URI, params, {
      headers: httpHeaders,
    });
  }

  updateWorkFlowCondition(token, workflowID, conditionID, params): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.put<any>(`${environment.apiUrl}/workflows/${workflowID}/conditions/${conditionID}`, params, {
      headers: httpHeaders,
    });
  }

  deleteWorkflowConditions(token, workflowID, conditionID): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.delete<any>(`${environment.apiUrl}/workflows/${workflowID}/conditions/${conditionID}`, {
      headers: httpHeaders,
    });
  }
}


